import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";
import { Status } from "../screens/Withdraw/Withdraw";

export interface AllWithdrawalResponse {
  data: Withdrawal[];
  meta: {
    totalRowCount: number;
  };
}

export interface Withdrawal {
  orgRoleId: string;
  id: number;
  companyName?: string;
  passportName?: string;
  amount: number;
  feesIncurred: number;
  currency: string;
  status: Status; // Use the enum type
  createdDate: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  actionDate?: string;
  approve?: boolean;
}

interface WithdrawalRequest {
  token: string;
  pagination?: MRT_PaginationState;
  columnFilters?: MRT_ColumnFiltersState;
  sorting?: MRT_SortingState;
}

const allWithdrawal = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: WithdrawalRequest): Promise<AllWithdrawalResponse> => {
  let url = `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/get-all-processing-withdraw`;
  try {
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        page: pagination?.pageIndex ? pagination.pageIndex + 1 : 1,
        pageSize: pagination?.pageSize || 10,
        columnFilters: columnFilters,
        sorting: sorting,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default allWithdrawal;
